import { actionCreatorFactory } from 'typescript-fsa';
import { FrontendConfig } from 'da-pcc-frontend-shared-domain';

const createAction = actionCreatorFactory('CONFIG');

const fetchConfig = createAction.async<void, FrontendConfig, Error>('FETCH');

export { fetchConfig };
